import { ToolbarConfig } from '@tencent/workbench';
import i18n from '@i18next/i18n';
import { ActionType } from '@editor/src/js/constants/common-action-type';


export const WIDTH_CONFIG = {
    id: ActionType.PICTURE_WIDTH,
    content: i18n.t('宽'),
};

export const HEIGHT_CONFIG = {
    id: ActionType.PICTURE_HEIGHT,
    content: i18n.t('高'),
};

export const SIZE_RATIO_CONFIG = {
    id: ActionType.SIZE_WITH_RATIO,
    content: i18n.t('锁定纵横比'),
};


export const TOOLBAR_ITEMS: ToolbarConfig[] = [
    {
        name: SIZE_RATIO_CONFIG.id,
        text: SIZE_RATIO_CONFIG.content,
        preventHighlight: true,
        style: {
            width: 'auto',
            height: 48,
            // marginLeft: -12,
            backgroundColor: '#fff',
        },
    },
];
